import React, { useState, useContext, memo, useMemo, useRef } from 'react';
import ReactCrop from "react-image-crop";
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import "react-image-crop/dist/ReactCrop.css";
import { Typography, IconButton, Avatar, Fab, Button, Grid, Slide, Dialog, DialogTitle, DialogContent, DialogActions, FormControl, RadioGroup, FormControlLabel, Radio, Snackbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import TransformIcon from '@material-ui/icons/Transform';
import CloudUploadRoundedIcon from '@material-ui/icons/CloudUploadRounded';
import { HttpService } from "../../apiAuthorization/httpService";
import { Theme } from '../contexts/themeContext.js';
import { User } from '../contexts/userContext.js';
import { Context } from '../contexts/siteContext.js';
import { Modules } from '../contexts/modulesContext';
import { Offline } from "../contexts/offlineContext";
import { GlobalTheme } from "../../layouts/theme";
import Settings from '../header/settings';
import Reports from '../header/reports';
import WeatherReport from '../header/weatherReport.js';
import { AppSettingMenu } from '../contexts/appSettingMenuContext';
import '../../css/common.css'

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function stringToHslColor(str, s, l) {
    let hash = 0;
    for (let index = 0; index < str.length; index++) {
        hash = str.charCodeAt(index) + ((hash << 5) - hash);
    }

    let h = hash % 360;
    return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
}

const useStyles = makeStyles(theme => ({
    root: {
        height: '250px',
        backgroundColor: theme.palette.background.paper
    },
    name: {
        paddingLeft: '10px'
    },
    userInfo: {
        float: 'right', padding: '10px', display: 'flex', alignItems: 'center',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '20px',
            float: 'left'
        }
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const UserAvatar = props => {
    const classes = useStyles();
    const importFileRef = useRef(null);
    const { theme } = useContext(Theme);
    const { defaultSite } = useContext(Context);
    const { userInfo, userDetail, setUserHeadImage } = useContext(User);
    const { showTraining, trainingMode, setTrainingMode, modules } = useContext(Modules);
    const { appSettingMenus } = useContext(AppSettingMenu);
    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
    const { offline } = useContext(Offline);
    const [avatarType, setAvatarType] = useState("Default");
    const [imageToCrop, setImageToCrop] = useState(null);
    const [croppedImage, setCroppedImage] = useState(null);
    const [cropConfig, setCropConfig] = useState({ unit: "%" });
    const [imageRef, setImageRef] = useState(null);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const currentTheme = GlobalTheme[theme];

    const initials = useMemo(() => {
        if (userDetail !== null) {
            let firstLetter = userDetail.pplPeoFirstName !== null ? userDetail.PplPeoFirstName.charAt(0) : "";
            let lastLetter = userDetail.pplPeoLastName !== "" ? userDetail.PplPeoLastName.charAt(0) : "";
            return (firstLetter + lastLetter);
        }
        else
            return "";
    }, [userDetail]);

    const bgColors = useMemo(() => {
        if (userDetail !== null)
            return (stringToHslColor(userDetail.pplPeoFirstName + userDetail.PplPeoLastName, 50, 30));
        else
            return "";
    }, [userDetail]);

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const openAvatar = () => {
        setAvatarType("Default");
        setImageToCrop(null);
        setCroppedImage(null);
        setCropConfig({ unit: "%" });
        setUploadDialogOpen(true);
        document.body.click();
    };

    const goToTrainingMode = () => {
        setTrainingMode(true);
        document.body.click();
    };

    const goToProductionMode = () => {
        setTrainingMode(false);
        document.body.click();
    };

    const browseFile = () => {
        importFileRef.current.click();
    };

    const onUploadFile = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            const reader = new FileReader();

            reader.addEventListener("load", () => {
                const image = reader.result;
                setImageToCrop(image);
            });

            reader.readAsDataURL(event.target.files[0]);
        }
    };

    function cropImage(crop) {
        if (imageRef && crop.width && crop.height) {
            const croppedImageTemp = getCroppedImage(imageRef, crop);
            setCroppedImage(croppedImageTemp);
        }
    }

    function getCroppedImage(sourceImage, cropConfigParam) {
        const canvas = document.createElement("canvas");
        const scaleX = sourceImage.naturalWidth / sourceImage.width;
        const scaleY = sourceImage.naturalHeight / sourceImage.height;
        canvas.width = cropConfigParam.width;
        canvas.height = cropConfigParam.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            sourceImage,
            cropConfigParam.x * scaleX,
            cropConfigParam.y * scaleY,
            cropConfigParam.width * scaleX,
            cropConfigParam.height * scaleY,
            0,
            0,
            cropConfigParam.width,
            cropConfigParam.height
        );

       return canvas.toDataURL("image/jpeg");
    }

    const avatarImageValueChanged = (e) => {
        setAvatarType(e.target.value);
        if (e.target.value === "Default") {
            setImageToCrop(null);
            setCroppedImage(null);
            setCropConfig({ unit: "%" });
        }
    };

    const cancel = () => {
        setUploadDialogOpen(false);
    };

    const saveAvatar = () => {
        if (avatarType === "UploadImage" && croppedImage === null) {
            setErrorMessage("Please upload the file and crop the image.");
            setOpenError(true);
        }
        else {
            HttpService.post('/Home/UploadHeadImage', { 'headImage': croppedImage })
                .then(result => {
                    setUploadDialogOpen(false);
                    setUserHeadImage(croppedImage);
                },
                    (error) => {
                        console.log(error);
                    }
                );
        }
    };

    return (
        <div className={classes.userInfo}>
            <Fab id="PopoverUserAvatar" size="small">
                {userInfo?.HeadImage && <Avatar src={userInfo?.HeadImage} />}
                {!userInfo?.HeadImage && <Avatar style={{ color: bgColors, backgroundColor: "#f1efef" }}> {initials} </Avatar>}
            </Fab>
            <UncontrolledPopover trigger="legacy" placement="bottom" target="PopoverUserAvatar" className="popoverContainer">
                <PopoverBody className={classes.root}>
                    <Grid container direction="row" alignItems="center" justify="center">
                        <Grid item>
                            <IconButton style={{ marginBottom: "10px" }} onClick={openAvatar}>
                                {userInfo?.HeadImage && <Avatar style={{ width: "80px", height: "80px" }} src={userInfo?.HeadImage} />}
                                {!userInfo?.HeadImage && <Avatar style={{ backgroundColor: bgColors, width: "80px", height: "80px" }}> {initials} </Avatar>}
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <Typography variant="h6" style={{ color: currentTheme.text, textTransform: "none" }}>{userDetail?.PplPeoFirstName}&nbsp;{userDetail?.PplPeoLastName}</Typography>
                            <Typography variant="body2" style={{ color: currentTheme.text, textTransform: "none" }}>{userInfo?.Title}</Typography>
                            <Typography variant="body2" style={{ color: currentTheme.text, textTransform: "none" }}>{userInfo?.Mail}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container direction="row" justify="center">
                        {(showTraining && !trainingMode) && <Button variant="contained" color="primary" size="small" className={classes.button} style={{ background: "#1976D2", marginRight: "10px" }} startIcon={<TransformIcon />} onClick={goToTrainingMode} disabled={offline === "1"}>Training</Button>}
                        {(showTraining && trainingMode) && <Button variant="contained" color="primary" size="small" className={classes.button} style={{ background: "#1976D2", marginRight: "10px" }} startIcon={<TransformIcon />} onClick={goToProductionMode} disabled={offline === "1"}>Production</Button>}
                    </Grid>
                    <Grid container
                        direction="row"
                        justify="space-evenly"
                        alignItems="center"
                        style={{ color: props.mode === 'dark' ? "#fff" : "black" }}
                    >
                        <Grid item>
                            <Reports theme={props.theme} defaultSite={defaultSite} modules={modules} appSettingMenus={appSettingMenus} trainingMode={trainingMode} />
                        </Grid>
                        <Grid item>
                            <Settings theme={props.theme} appSettingMenus={appSettingMenus} trainingMode={trainingMode} />
                        </Grid>
                        <WeatherReport />
                        {/*<Grid item>*/}
                        {/*</Grid>*/}
                        {/*<Grid item>*/}
                        {/*    <IconButton color="inherit" onClick={props.themeChange} style={{ paddingTop: '0px', paddingBottom: '0px' }} disableRipple={true}>*/}
                        {/*        <div style={{ display: 'block' }}>*/}
                        {/*            {props.mode === 'dark' ? (<WbSunnyIcon />) : (<Brightness4Icon />)}*/}
                        {/*            <Typography variant="caption" display="block">Theme</Typography>*/}
                        {/*        </div>*/}
                        {/*    </IconButton>*/}
                        {/*</Grid>*/}
                    </Grid>
                </PopoverBody>
            </UncontrolledPopover>
            <Dialog maxWidth="md" fullWidth={true} open={uploadDialogOpen} classes={{ paper: classes.dialog }} TransitionComponent={Transition}>
                <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeErrorSnackbar} severity="error">
                        {errorMessage}
                    </Alert>
                </Snackbar>
                <DialogTitle>
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={12} sm={6}>Avatar Image</Grid>
                        <Grid item xs={12} sm={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                            <FormControl>
                                <RadioGroup row name="AvatarImage" defaultValue="Default" onChange={avatarImageValueChanged}>
                                    <FormControlLabel value="Default" control={<Radio />} label="Default" />
                                    <FormControlLabel value="UploadImage" control={<Radio />} label="Upload Image" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent dividers style={{ height: "500px" }}>
                    {avatarType === "Default" &&
                        <><Typography variant="subtitle1" style={{ textTransform: "none" }}>Default image will be used. Select upload image above and follow instructions to customize user avatar.</Typography>
                            <Grid container justify="center">
                                <Grid item style={{ marginTop: "100px" }}>
                                    <Avatar style={{ width: "100px", height: "100px", backgroundColor: bgColors }}> {initials} </Avatar>
                                </Grid>
                            </Grid>
                        </>
                    }
                    {avatarType === "UploadImage" &&
                        <>
                            <Grid container direction="row" alignItems="center">
                                <Grid item>
                                    <Button autoFocus
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        style={{ background: currentTheme.secondary }}
                                        startIcon={<CloudUploadRoundedIcon />}
                                        onClick={browseFile}
                                    >
                                        Choose File
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1" style={{ textTransform: "none" }}>&nbsp;&nbsp;Select a .JPG or .PNG file from your computer for the profile picture.</Typography>
                                </Grid>
                            </Grid>
                            <input type="file" ref={importFileRef} accept="image/*" onChange={onUploadFile} style={{ display: "none" }} />
                            <br /><br />
                            <Grid container spacing={2} justify="center" alignItems="center">
                                <Grid item xs={8}>
                                    <ReactCrop
                                        src={imageToCrop}
                                        crop={cropConfig}
                                        onImageLoaded={(imageRef) => setImageRef(imageRef)}
                                        onComplete={(cropConfig) => cropImage(cropConfig)}
                                        onChange={(cropConfig) => setCropConfig(cropConfig)}
                                    />
                                </Grid>
                                <Grid item xs={4} style={{ display: "flex", justifyContent: "center" }}>
                                    {croppedImage && (
                                        <Avatar style={{ width: "100px", height: "100px" }} src={croppedImage} />
                                    )}
                                </Grid>
                            </Grid>
                        </>
                    }
                </DialogContent>
                <DialogActions>
                    <Button 
                        variant="contained"
                        color="primary"
                        size="small"
                        className={classes.button}
                        style={{ background: currentTheme.secondary, width: "100px" }}
                        startIcon={<SaveIcon />}
                        onClick={saveAvatar}
                    >
                        Save
                    </Button>
                    <Button autoFocus
                        variant="contained"
                        color="secondary"
                        size="small"
                        className={classes.button}
                        style={{ width: "100px", marginRight: "20px" }}
                        startIcon={<CancelIcon />}
                        onClick={cancel}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default memo(UserAvatar);
